<template>
  <div class="logoutlist">
    <div class="top">
      <div class="querybox">
        <div>
          <p>手机号/登陆账号：</p>
          <el-input
            v-model="queryParams.phone"
            placeholder="请输入手机号/登陆账号"
            clearable
          ></el-input>
        </div>
        <div>
          <p>昵称：</p>
          <el-input
            v-model="queryParams.nickname"
            placeholder="请输入昵称"
            clearable
          ></el-input>
        </div>
        <div>
          <p>时间筛选：</p>
          <!-- <el-date-picker
            v-model="value"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="timeChange"
          >
          </el-date-picker> -->
          <el-date-picker
            v-model="value"
            align="right"
            type="date"
            placeholder="选择时间"
            :picker-options="pickerOptions"
            @change="timeChange"
          ></el-date-picker>
        </div>
      </div>
      <div class="handlebox">
        <div class="btnbox">
          <el-button
            type="primary"
            icon="el-icon-refresh-right"
            class="reset-btn"
            style="color: #1d2129"
            @click="resetFn"
            >重置</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-search"
            class="search-btn"
            @click="search"
            >查询</el-button
          >
        </div>
      </div>
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        show-overflow-tooltip
      >
        <el-table-column prop="headImg" label="头像">
          <template slot-scope="{ row }">
            <div class="logo">
              <img :src="row.headImg" alt="" />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号/登陆账号"></el-table-column>
        <el-table-column prop="nickname" label="昵称"></el-table-column>
        <el-table-column prop="updatedTime" label="注销时间" min-width="120">
        </el-table-column>
        <el-table-column prop="logoutReason" label="注销原因" min-width="120">
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination
        v-show="total > queryParams.pageSize"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="init"
      />
    </div>
  </div>
</template>

<script>
import { getLogoutList } from "@/api/login";
export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        phone: "",
        nickname: "",
        startTime: "",
        endTime: "",
      },
      tableData: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      value: "",
      total: 0, //总数
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //获取用户列表
    async init() {
      const res = await getLogoutList(this.queryParams);
      this.tableData = res.result.records;
      this.total = res.result.total;
    },
    timeChange(event) {
      // console.log(event);
      if (event) {
        this.queryParams.startTime = this.$moment(event)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        this.queryParams.endTime = this.$moment()
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      } else {
        this.queryParams.startTime = "";
        this.queryParams.endTime = "";
      }
      // console.log(this.queryParams);
    },
    // 查询
    search() {
      this.queryParams.pageNum = 1;
      this.init();
    },
    //重置
    resetFn() {
      this.queryParams.phone = "";
      this.queryParams.nickname = "";
      this.queryParams.pageNum = 1;
      this.queryParams.startTime = "";
      this.queryParams.endTime = "";
      this.value = "";
      this.init();
    },
  },
};
</script>
<style lang="scss" scoped>
.logoutlist {
  .top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 32px;
    ::v-deep .querybox {
      display: flex;
      align-items: center;

      > div {
        display: flex;
        align-items: center;
        margin-right: 24px;
        p {
          font-weight: 400;
          font-size: 14px;
          color: #262626;
          line-height: 20px;
          white-space: nowrap;
        }
        .el-input,
        .el-range-editor {
          width: 200px;
        }
        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: rgba(0, 0, 0, 0.25);
        }
        .el-input__inner {
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #d9d9d9;
        }
      }
    }
    .handlebox {
      display: flex;
      align-items: center;
    }
  }
  .content {
    padding-top: 20px;
    .logo {
      display: flex;
      justify-content: center;
      img {
        width: 38px;
        height: 38px;
        border-radius: 100%;
      }
    }
    .el-button {
      padding: 5px 0;
      width: 80px;
      box-sizing: border-box;
    }
  }
  .textred-btn,
  .textblue-btn {
    padding: 0 5px;
  }
}
</style>
